export default {
    name: 'PremiumRestrictedAction',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean },
    methods: {
        openSubscriptionModal() {
            this.$emit('openSubscriptionAlertModal');
            this.$emit('close', false);
        }
    }
};
